// src/utils/svg-icons.js
// 匹配所有子目录下的SVG文件
const modules = import.meta.glob("@/assets/sysIcons/**/*.svg", { eager: true, as: "raw" })

// 生成包含分类和名称信息的数组
const sysIcons = []
// 基础路径，用于截取相对路径
const basePath = "src/assets/sysIcons/"

for (const path in modules) {
  // 截取相对于sysIcons文件夹的路径
  const relativePath = path.slice(basePath.length)
  // 分割路径为目录和文件名部分
  const pathParts = relativePath.split("/")
  // 文件名（不带扩展名）
  const fileName = pathParts.pop().replace(".svg", "")
  // 分类（子文件夹名称，根目录下的文件分类为'root'）
  const category = pathParts.length > 0 ? pathParts.join("/") : "root"
  
  // 添加到数组
  sysIcons.push({
    category,
    name: fileName,
    svg: modules[path]
  })
}

export default sysIcons
